import { useState, useSyncExternalStore } from 'react';
import { PromptDialog } from '../components/ui/Prompt';
import { ApiError } from './api';

/**
 * 0.79: Verbindliche Spaltenregeln. Der Server antwortet mit 422 und `details.gate`. Besitzer*innen dürfen
 * (falls die Regel es erlaubt) mit Begründung übergehen – dafür ein globaler Dialog.
 */
export interface GateInfo {
  side: 'entry' | 'exit';
  columnId: string;
  columnTitle: string;
  unmet: string[];
  canOverride: boolean;
}

export function gateOf(err: unknown): GateInfo | null {
  if (!(err instanceof ApiError) || err.status !== 422) return null;
  const d = err.data as { details?: { gate?: GateInfo } } | undefined;
  return d?.details?.gate ?? null;
}

type Pending = { message: string; retry: (reason: string) => Promise<void> };
let pending: Pending | null = null;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

/** Dialog „Regel übergehen“ öffnen; `retry` wiederholt die Aktion mit Begründung */
export function askGateOverride(message: string, retry: (reason: string) => Promise<void>) {
  pending = { message, retry };
  emit();
}

export function GateOverrideHost() {
  const p = useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => pending,
  );
  const [busy, setBusy] = useState(false);
  const close = () => {
    pending = null;
    emit();
  };
  return (
    <PromptDialog
      open={!!p}
      title="Spaltenregel übergehen"
      label="Begründung (steht im Verlauf der Karte)"
      confirm={busy ? 'Wird verschoben …' : 'Trotzdem verschieben'}
      hint={p ? `${p.message} Als Besitzer*in darfst du die Regel ausnahmsweise übergehen.` : undefined}
      onClose={close}
      onSubmit={(reason) => {
        if (!p || busy || reason.trim().length < 3) return;
        setBusy(true);
        void p.retry(reason.trim()).finally(() => {
          setBusy(false);
          close();
        });
      }}
    />
  );
}
